<template>
    <div class="container">
        <div class="card">
            <div class="card-body">
                <div v-if="source !== ''" >
                    <div class="card-subtitle">
                        <br/>
                        <span class="bold">From:</span> {{source}} <br/>
                        <span class="bold">To:</span> {{destination}} <br/>
                        <span class="bold">Time:</span> {{time}} <br/><br/>
                    </div>
                    <div class="card-text">
                        {{message}}<br/><br/>
                        
                    </div>
                    
                </div>
                <div v-else >
                    <div class="col-12">
                        Message not Found.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import localForage from "localforage";
import NavBarComponent from '../components/NavBarComponent'


export default {
    name:"message",
    components:{NavBarComponent},
    data() {
        return {
            source:'',
            destination:'',
            message:'',
            time:'',
            id:''
        }
    },
    mounted() {
        let _this = this;
        localForage.getItem(this.$route.query.id,function (err, payload) {
            _this.$util.log('mounted payload:',payload);
            if ( payload !== null ) {
                _this.id = _this.$route.query.id;
                _this.source = payload.source;
                _this.destination = payload.destination;
                _this.message = payload.message;
                _this.time = _this.$util.unixTimeToDate(payload.time);
                localForage.removeItem(_this.$route.query.id);
            }
        });        
    }
}
</script>

<style scoped>
.bold{
    font-weight: bold;
}
</style>
